/* GOALDRIP — interactions des sections d'accueil (carrousel 3D, onglets, vidéos, ajout panier). */

const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

let eventsModule = null;
async function getEvents() {
  if (eventsModule !== null) return eventsModule;
  try {
    eventsModule = await import('@shopify/events');
  } catch (e) {
    eventsModule = false;
  }
  return eventsModule;
}

function toast(message, withCartLink) {
  let el = document.querySelector('.gd-toast');
  if (!el) {
    el = document.createElement('div');
    el.className = 'gd-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    document.body.appendChild(el);
  }
  el.textContent = message;
  if (withCartLink) {
    const a = document.createElement('a');
    a.href = root() + 'cart';
    a.textContent = 'Voir le panier';
    el.appendChild(a);
  }
  requestAnimationFrame(() => el.classList.add('is-visible'));
  clearTimeout(el._t);
  el._t = setTimeout(() => el.classList.remove('is-visible'), 3200);
}

/** Ajoute une ou plusieurs lignes au panier et prévient le thème (bulle du panier, tiroir). */
export async function gdAddToCart(items, sourceEl) {
  const lines = items.map((it) => ({ id: Number(it.id), quantity: it.quantity || 1 }));
  const events = await getEvents();
  let deferred = null;
  if (events && events.CartLinesUpdateEvent) {
    try {
      deferred = events.CartLinesUpdateEvent.createPromise();
      (sourceEl || document).dispatchEvent(
        new events.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity })),
          promise: deferred.promise,
        })
      );
    } catch (e) {
      deferred = null;
    }
  }
  try {
    const res = await fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines }),
    });
    const data = await res.json();
    const cart = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    if (deferred) {
      deferred.resolve({
        cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse
          ? events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart)
          : cart,
        detail: { items: cart.items, itemCount: cart.item_count, source: 'goaldrip', didError: !res.ok },
      });
    }
    if (!res.ok) {
      toast(data.description || data.message || 'Impossible d’ajouter ce produit', false);
      return false;
    }
    toast(lines.length > 1 ? 'Look ajouté au panier' : 'Ajouté au panier', true);
    return true;
  } catch (err) {
    if (deferred) deferred.reject(err);
    toast('Erreur réseau, réessaie', false);
    return false;
  }
}

function markAdded(btn, label) {
  const original = btn.dataset.label || btn.textContent;
  btn.dataset.label = original;
  btn.classList.add('is-added');
  btn.textContent = label || 'Ajouté ✓';
  setTimeout(() => {
    btn.classList.remove('is-added');
    btn.textContent = original;
  }, 2200);
}

/* Boutons d'ajout simples : <button data-gd-add data-variant-id="..."> */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-gd-add]');
  if (!btn || btn.closest('gd-hero') || btn.hasAttribute('data-gd-look')) return;
  e.preventDefault();
  if (btn.disabled || !btn.dataset.variantId) return;
  btn.disabled = true;
  const ok = await gdAddToCart([{ id: btn.dataset.variantId }], btn);
  btn.disabled = false;
  if (ok) markAdded(btn, btn.dataset.addedLabel);
});

/* Look complet : <button data-gd-add data-gd-look data-variant-ids="1,2,3"> */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-gd-look]');
  if (!btn) return;
  e.preventDefault();
  const ids = (btn.dataset.variantIds || '').split(',').filter(Boolean);
  if (!ids.length || btn.disabled) return;
  btn.disabled = true;
  const ok = await gdAddToCart(ids.map((id) => ({ id })), btn);
  btn.disabled = false;
  if (ok) markAdded(btn, 'Look ajouté ✓');
});

/* ---------- Carrousel 3D de l'accueil ---------- */
class GdHero extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;
    this.ring = this.querySelector('[data-ring]');
    this.stage = this.querySelector('[data-stage]');
    this.cards = [...this.querySelectorAll('[data-card]')];
    this.infos = [...this.querySelectorAll('[data-info]')];
    this.dots = [...this.querySelectorAll('[data-dot]')];
    this.counter = this.querySelector('[data-counter]');
    this.n = this.cards.length;
    this.idx = 0;
    this.rot = 0;
    this.touched = false;
    if (!this.n) return;

    this.layout();
    this._onResize = () => this.layout();
    window.addEventListener('resize', this._onResize);

    this.cards.forEach((card, i) =>
      card.addEventListener('click', () => {
        if (this._swiped) {
          this._swiped = false;
          return;
        }
        if (i === this.idx && card.dataset.url) {
          window.location.href = card.dataset.url;
          return;
        }
        this.pick(i, true);
      })
    );
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.pick(i, true)));
    this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(-1, true));
    this.querySelector('[data-next]')?.addEventListener('click', () => this.go(1, true));

    this.stage.addEventListener('pointerdown', (e) => {
      this._sx = e.clientX;
      this._swiped = false;
    });
    this.stage.addEventListener('pointerup', (e) => {
      if (this._sx == null) return;
      const dx = e.clientX - this._sx;
      this._sx = null;
      if (Math.abs(dx) > 40) {
        this._swiped = true;
        this.go(dx < 0 ? 1 : -1, true);
      }
    });
    this.stage.addEventListener('pointercancel', () => (this._sx = null));
    this.addEventListener('keydown', (e) => {
      if (e.target.closest('input, select, textarea')) return;
      if (e.key === 'ArrowRight') this.go(1, true);
      if (e.key === 'ArrowLeft') this.go(-1, true);
    });

    // Tailles / variantes
    this.infos.forEach((info) => {
      const add = info.querySelector('[data-hero-add]');
      info.querySelectorAll('[data-variant]').forEach((pill) =>
        pill.addEventListener('click', () => {
          info.querySelectorAll('[data-variant]').forEach((p) => p.setAttribute('aria-pressed', 'false'));
          pill.setAttribute('aria-pressed', 'true');
          if (add) {
            add.dataset.variantId = pill.dataset.variant;
            add.disabled = false;
            add.textContent = add.dataset.label || 'Ajouter au panier';
          }
          const price = info.querySelector('[data-price]');
          if (price && pill.dataset.price) price.innerHTML = pill.dataset.price;
          this.touched = true;
        })
      );
      add?.addEventListener('click', async () => {
        if (!add.dataset.variantId || add.disabled) return;
        add.disabled = true;
        const ok = await gdAddToCart([{ id: add.dataset.variantId }], add);
        add.disabled = false;
        if (ok) markAdded(add);
      });
    });

    this.render();

    const autoplay = this.dataset.autoplay === 'true' && !reduceMotion();
    if (autoplay && this.n > 1) {
      this._timer = setInterval(() => {
        if (!this.touched && !document.hidden && !this.matches(':hover')) this.go(1, false);
      }, 3500);
    }
  }

  disconnectedCallback() {
    clearInterval(this._timer);
    window.removeEventListener('resize', this._onResize);
  }

  layout() {
    const w = this.stage.clientWidth;
    const cardW = Math.max(130, Math.min(220, Math.round(w * (w < 600 ? 0.4 : 0.34))));
    this.style.setProperty('--gd-card-w', cardW + 'px');
    const step = 360 / this.n;
    const radius = this.n < 3 ? cardW : Math.round(cardW / 2 / Math.tan(Math.PI / this.n) + cardW * 0.35);
    this.cards.forEach((card, i) => {
      card.style.transform = `rotateY(${i * step}deg) translateZ(${radius}px)`;
    });
    this.step = step;
    this.render();
  }

  go(d, user) {
    this.idx = (((this.idx + d) % this.n) + this.n) % this.n;
    this.rot -= d * this.step;
    if (user) this.touched = true;
    this.render();
  }

  pick(i, user) {
    let d = i - this.idx;
    if (d > this.n / 2) d -= this.n;
    if (d < -this.n / 2) d += this.n;
    if (user) this.touched = true;
    if (d !== 0) this.go(d, user);
  }

  render() {
    if (!this.ring) return;
    this.ring.style.transform = `rotateX(-6deg) rotateY(${this.rot}deg)`;
    this.cards.forEach((c, i) => {
      c.classList.toggle('is-dim', i !== this.idx);
      c.setAttribute('aria-current', i === this.idx ? 'true' : 'false');
      c.tabIndex = i === this.idx ? 0 : -1;
    });
    this.dots.forEach((d, i) => d.setAttribute('aria-current', i === this.idx ? 'true' : 'false'));
    this.infos.forEach((info, i) => (info.hidden = i !== this.idx));
    if (this.counter) this.counter.textContent = String(this.idx + 1).padStart(2, '0') + ' / ' + String(this.n).padStart(2, '0');
  }
}
if (!customElements.get('gd-hero')) customElements.define('gd-hero', GdHero);

/* ---------- Onglets de la sélection ---------- */
class GdTabs extends HTMLElement {
  connectedCallback() {
    const tabs = [...this.querySelectorAll('[role="tab"]')];
    const panels = [...this.querySelectorAll('[role="tabpanel"]')];
    const select = (i, focus) => {
      tabs.forEach((t, k) => {
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        t.tabIndex = k === i ? 0 : -1;
      });
      panels.forEach((p, k) => (p.hidden = k !== i));
      if (focus) tabs[i].focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i));
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') select((i + 1) % tabs.length, true);
        if (e.key === 'ArrowLeft') select((i - 1 + tabs.length) % tabs.length, true);
      });
    });
  }
}
if (!customElements.get('gd-tabs')) customElements.define('gd-tabs', GdTabs);

/* ---------- Effet d'inclinaison 3D sur les cartes produits ---------- */
if (!reduceMotion() && window.matchMedia('(hover: hover)').matches) {
  document.addEventListener('pointermove', (e) => {
    const media = e.target.closest && e.target.closest('.gd-card__media');
    document.querySelectorAll('.gd-card__media.is-tilting').forEach((m) => {
      if (m !== media) {
        m.classList.remove('is-tilting');
        m.style.transform = '';
        m.style.boxShadow = '';
      }
    });
    if (!media) return;
    const r = media.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    media.classList.add('is-tilting');
    media.style.transform = `rotateX(${(-y * 16).toFixed(1)}deg) rotateY(${(x * 16).toFixed(1)}deg) translateZ(10px)`;
    media.style.boxShadow = '0 40px 50px -28px rgba(14,15,12,.6)';
  });
}

/* ---------- Vidéos du feed : lecture / pause au toucher ---------- */
document.addEventListener('click', (e) => {
  const media = e.target.closest('[data-gd-video]');
  if (!media) return;
  const video = media.querySelector('video');
  if (!video) return;
  document.querySelectorAll('[data-gd-video] video').forEach((v) => {
    if (v !== video && !v.paused) {
      v.pause();
      v.closest('[data-gd-video]').classList.remove('is-playing');
      v.closest('[data-gd-video]').setAttribute('aria-pressed', 'false');
    }
  });
  if (video.paused) {
    video.play();
    media.classList.add('is-playing');
    media.setAttribute('aria-pressed', 'true');
  } else {
    video.pause();
    media.classList.remove('is-playing');
    media.setAttribute('aria-pressed', 'false');
  }
});
/* GOALDRIP couleur -> image (carrousel, La sélection, Compose ton look) */
(()=>{const e=/^(couleur|coloris|color|colour)$/i,t=window.Shopify&&Shopify.routes&&Shopify.routes.root||"/",r=(e,t)=>e?e.replace(/^http:/,"https:")+(e.includes("?")?"&":"?")+"width="+t:"",i={},a=e=>i[e]||(i[e]=fetch(t+"products/"+e+".js").then(e=>e.ok?e.json():null).catch(()=>null));function o(t){const r=t.options.findIndex(t=>e.test("string"==typeof t?t:t.name));if(r<0)return null;const i=new Map;t.variants.forEach(e=>{const t=e.options?e.options[r]:e["option"+(r+1)];if(!t)return;const a=i.get(t)||{name:t,img:null,variant:null,available:!1},o=e.featured_image&&(e.featured_image.src||e.featured_image);!a.img&&o&&(a.img=o),(!a.variant||!a.available&&e.available)&&(a.variant=e),e.available&&(a.available=!0),i.set(t,a)});(t.images||[]).map(e=>"string"==typeof e?e:e.src);return i.forEach(e=>{if(!e.img){const r=e.name.toLowerCase(),i=(t.media||[]).find(e=>e.alt&&e.alt.toLowerCase().includes(r));e.img=i?i.src||i.preview_image&&i.preview_image.src:null}}),i.size>1?[...i.values()]:null}async function n(e){if(e.dataset.gdSw)return;e.dataset.gdSw="1";const t=e.querySelector('a.gd-card__media[href*="/products/"]');if(!t)return;const i=t.getAttribute("href").split("/products/")[1].split(/[?#]/)[0],n=await a(i);if(!n)return;const s=o(n);if(!s)return;const c=t.querySelector("img"),l=[...e.querySelectorAll('a[href*="/products/'+i+'"]')],d=l.map(e=>e.getAttribute("href").split("?")[0]),u=function(e,t,i){const a=document.createElement("div");return a.className=i,a.setAttribute("role","radiogroup"),a.setAttribute("aria-label","Couleur"),e.forEach((e,i)=>{const o=document.createElement("button");if(o.type="button",o.className="gd-sw",o.title=e.name,o.setAttribute("aria-label",e.name),o.setAttribute("aria-checked","false"),o.setAttribute("role","radio"),e.available||o.classList.add("is-oos"),e.img){const t=document.createElement("img");t.alt="",t.loading="lazy",t.src=r(e.img,80),o.appendChild(t)}else o.textContent=e.name.slice(0,2);o.addEventListener("click",r=>{r.preventDefault(),r.stopPropagation(),a.querySelectorAll(".gd-sw").forEach(e=>e.setAttribute("aria-checked","false")),o.setAttribute("aria-checked","true"),t(e)}),a.appendChild(o)}),a}(s,(e,t)=>{e.img&&c&&(c.removeAttribute("srcset"),c.src=r(e.img,800)),!t&&e.variant&&l.forEach((t,r)=>t.setAttribute("href",d[r]+"?variant="+e.variant.id))},"gd-card__swatches"),p=e.querySelector(".gd-card__price");(p?p.parentNode:e).appendChild(u)}function s(t){if(t.dataset.gdSw)return;t.dataset.gdSw="1";const i=[...t.querySelectorAll("[data-card]")];[...t.querySelectorAll("[data-info]")].forEach((t,n)=>{const s=i[n];if(!s||!s.dataset.url)return;const c=s.dataset.url.split("/products/")[1];if(!c)return;const l=c.split(/[?#]/)[0];t.addEventListener("click",async t=>{const i=t.target.closest(".gd-pill");if(!i)return;const n=i.closest(".gd-hopt"),c=n&&n.querySelector(".gd-hopt__l");if(!c||!e.test(c.textContent.trim()))return;const d=await a(l);if(!d)return;const u=o(d);if(!u)return;const p=u.find(e=>e.name===i.dataset.val);if(!p)return;const g=s.querySelector("img");g&&p.img&&(g.removeAttribute("srcset"),g.src=r(p.img,600)),p.variant&&(s.dataset.url="/products/"+l+"?variant="+p.variant.id)}),a(l).then(i=>{const a=i&&o(i);a&&t.querySelectorAll(".gd-hopt").forEach(t=>{const i=t.querySelector(".gd-hopt__l");i&&e.test(i.textContent.trim())&&t.querySelectorAll(".gd-pill").forEach(e=>{const t=a.find(t=>t.name===e.dataset.val);if(t&&t.img&&!e.querySelector("img")){const i=document.createElement("img");i.alt="",i.src=r(t.img,60),e.classList.add("gd-lb__pill--sw"),e.prepend(i)}})})})})}function c(e){(e||document).querySelectorAll("gd-hero").forEach(s),(e||document).querySelectorAll(".gd-card").forEach(n)}const l=document.createElement("style");l.textContent='.gd-card__swatches{display:flex;flex-wrap:wrap;gap:6px;margin-top:8px}.gd-sw{width:30px;height:30px;padding:0;border-radius:50%;border:1px solid rgba(127,127,127,.35);background:#f4f2ec;overflow:hidden;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;font-size:10px;line-height:1;transition:box-shadow .15s}.gd-sw img{width:100%;height:100%;object-fit:cover}.gd-sw[aria-checked="true"]{box-shadow:0 0 0 2px var(--gd-accent,#c8f031)}.gd-sw.is-oos{opacity:.4}.gd-lb__pill--sw{display:inline-flex;align-items:center;gap:6px}.gd-lb__pill--sw img{width:22px;height:22px;border-radius:50%;object-fit:cover}.gd-lb__preview{margin:10px 0}.gd-lb__preview img{display:block;width:100%;max-width:260px;aspect-ratio:1;object-fit:contain;border-radius:12px;background:#f4f2ec}',document.head.appendChild(l);const d=()=>{c(),new MutationObserver(e=>e.forEach(e=>e.addedNodes.forEach(e=>{1===e.nodeType&&(e.matches&&e.matches(".gd-card")?n(e):c(e))}))).observe(document.body,{childList:!0,subtree:!0})};"loading"===document.readyState?document.addEventListener("DOMContentLoaded",d):d(),customElements.whenDefined("gd-look-builder").then(function(){const t=customElements.get("gd-look-builder");if(!t||t.prototype._gdColor)return;t.prototype._gdColor=!0;const i=t.prototype.load;t.prototype.load=async function(e){await i.call(this,e);try{const t={};for(let r=1;r<=4;r++){const i=await fetch(e.url+"/products.json?limit=250&page="+r);if(!i.ok)break;const a=(await i.json()).products||[];if(a.forEach(e=>{const r={};(e.images||[]).forEach(e=>(e.variant_ids||[]).forEach(t=>r[t]=e.src)),t[e.id]={byId:r,imgs:e.images||[]}}),a.length<250)break}e.products.forEach(e=>{const r=t[e.id];r&&(e.baseImg=e.img,e.variants.forEach(e=>{e.img=r.byId[e.id]||null}))})}catch(e){}};const a=t.prototype.renderSizes;t.prototype.renderSizes=function(t){a.call(this,t);const i=t.product;if(!i||i.simple)return;const o=i.options.findIndex(t=>e.test(t));if(o<0)return;const n=t.el.querySelectorAll("[data-sizes] .gd-lb__optrow")[o];if(!n)return;n.querySelectorAll(".gd-lb__pill").forEach(e=>{const t=e.textContent,a=i.variants.find(e=>e.options[o]===t&&e.img);if(a&&!e.querySelector("img")){const t=document.createElement("img");t.alt="",t.src=r(a.img,60),e.classList.add("gd-lb__pill--sw"),e.prepend(t)}});const s=t.sel[o],c=s&&i.variants.find(e=>e.options[o]===s&&e.img),l=c?c.img:i.baseImg||i.img;l&&l!==i.img&&(i.img=l,this.renderRail(t));let d=t.el.querySelector("[data-gd-preview]");if(c){d||(d=document.createElement("div"),d.className="gd-lb__preview",d.setAttribute("data-gd-preview",""),t.el.querySelector("[data-sizes]").before(d)),d.innerHTML="";const e=document.createElement("img");e.alt=i.title+" – "+s,e.src=r(c.img,500),d.appendChild(e)}else d&&d.remove()},document.querySelectorAll("gd-look-builder").forEach(e=>{e._ready&&e.steps&&e.steps.forEach(t=>{e.load(t)})})})})();
